// extracted by mini-css-extract-plugin
export default {"card":"GeneralTabPanel_card__788GV","container":"GeneralTabPanel_container__3yqIF","panel":"GeneralTabPanel_panel__5mCHx"};